<template>
	<div class="templates">
		<form>
		<md-field class="md-field-margin">
			<label>Email Template:</label>
			<md-input v-model="template.name" name="name" v-validate="'required|max:60'" @input="sanitizeName"></md-input>
		</md-field>
		<p v-show="errors.has('name')" v-text="errors.first('name')" class="error"></p>
		<md-field class="md-field-margin">
			<label>Description:</label>
			<md-input v-model="template.description" name="description" v-validate="'required|max:100'" @input="sanitizeDescription"></md-input>
		</md-field>
			<p class="error" v-show="errors.has('description')" v-text="errors.first('description')"></p>
		<md-field class="md-field-margin">
			<label>Subject:</label>
			<md-input v-model="template.subject" name="subject" v-validate="'required|max:100'" @input="sanitizeSubject"></md-input>
		</md-field>
			<p class="error" v-show="errors.has('subject')" v-text="errors.first('subject')"></p>
		<md-field class="md-field-margin">
			<label>Body HTML:</label>
			<md-textarea v-model="template.html" name="body html" v-validate="'required'" @blur="template.html = $event.target.value" ></md-textarea>
		</md-field>
			<p class="error" v-show="errors.has('body html')" v-text="errors.first('body html')"></p>
		<md-field class="md-field-margin">
			<label>Body Text:</label>
			<md-textarea v-model="template.text" name="body text" v-validate="'required|max:5000'" @input="sanitizeText"></md-textarea>
		</md-field>
			<p class="error" v-show="errors.has('body text')" v-text="errors.first('body text')"></p>
		<md-field class="md-field-margin">
			<label>Email Category:</label>
			<md-select v-model="template.category" name="Email category"  v-validate="'required'" placeholder="Email category" id="category">
				<md-option value="None">None (no category)</md-option>
				<md-option value="Approvals">Approvals</md-option>
				<md-option value="Escalate">Escalate</md-option>
				<md-option value="Requests">Requests</md-option>
				<md-option value="Responses">Responses</md-option>
				<md-option value="Feedback">Feedback</md-option>
				<md-option value="Referee">Referee</md-option>
				<md-option value="Unsubscribe">Unsubscribe</md-option>
				<md-option value="Members">Members</md-option>
				<md-option value="Reports">Reports</md-option>
				<md-option value="recruiting">Recruiting</md-option>
				<md-option value="profileUpdate">Profile Update</md-option>
				<md-option value="noFollowUp">No Follow Up</md-option>
			</md-select>
		</md-field>
			<p class="error" v-show="errors.has('Email category')" v-text="errors.first('Email category')"></p>
		<md-field class="md-field-margin">
			<!-- <md-button class="md-raised md-round md-accent" @click="save" :disabled="this.errors.any()">{{ saveText }}</md-button> -->
			<md-button class="md-raised md-round md-accent" @click="save">{{ saveText }}</md-button>
		</md-field>
		</form>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import { sanitizeInput, sanitizeHtmlTemplate } from "../utils/sanitizer";
export default {
  data() {
    return {
      api: new API(),
      saveText: "save",
      template: {
	      name: '',
	      description: '',
	      subject: '',
	      html: '',
	      text: ''
      }
    };
  },
  methods: {
	sanitizeName(value) {
      this.template.name = sanitizeInput(value);
    },
    sanitizeDescription(value) {
      this.template.description = sanitizeInput(value);
    },
    sanitizeSubject(value) {
      this.template.subject = sanitizeInput(value);
    },
    /*sanitizeHtml(value) {
      return sanitizeHtmlTemplate(value);
    },*/
    sanitizeText(value) {
      this.template.text = sanitizeInput(value);
    },
    loadData: async function() {
      await this.api.get(`templates/${this.template_id}`).then(template => {
        this.template = template.data;
      });
    },
    save: async function() {
	    this.$validator.validateAll().then((result) => {
        if (result) {
          // Sanitize all fields one final time before saving
          const sanitizedTemplate = {
            name: sanitizeInput(this.template.name),
            description: sanitizeInput(this.template.description),
            subject: sanitizeInput(this.template.subject),
            html: this.template.html,
            text: sanitizeInput(this.template.text),
            category: this.template.category // No need to sanitize as it's from select
          };

          console.log("sanitized :", sanitizedTemplate);
          this.api.post('templates', sanitizedTemplate).then(template => {
            this.$emit("reload");
            this.$router.push('/');
          }).catch(err => {
            return new Promise((resolve, reject) => {
              resolve(err);
              if (err.response.status === 500) {
                this.errors.add({field: 'name', msg: err.response.data.message});
              }
            });
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CreateTemplate.vue